import React from "react"
import { Link } from "gatsby"
import { DropWrap, DropBody, Divider, Triangle } from "./ElectronicMenu"
import { StaticQuery, graphql } from "gatsby"

function ImagingMenu(props) {
  const { display, top } = props
  return (
    <StaticQuery
      query={graphql`
        query KioskPrinterRepairMenuQuery {
          allContentfulServiceSubRepair(
            filter: {
              service: {
                serviceName: { eq: "Kiosk & Printer Repair Services" }
              }
            }
          ) {
            nodes {
              name
              url
            }
          }
        }
      `}
      render={(data) => {
        return (
          <DropWrap display={display} top={top} className="dropdown">
            <Triangle className="dropdown-arrow"/>
            <DropBody className="dropdown-body">
              {data.allContentfulServiceSubRepair.nodes.map((subMenu, i) => {
                return (
                  <div key={`${subMenu}-${i}`}>
                    <Link to={`/${subMenu.url}`}>{subMenu.name}</Link>
                    <Divider />
                  </div>
                )
              })}
            </DropBody>
          </DropWrap>
        )
      }}
    />
  )
}

export default ImagingMenu
